module.exports = __webpack_public_path__ + "img/nav_application_yqly.ad139040.png";